/** @param raw - User input (may include +56, spaces, dashes). @returns 9-digit string (e.g. "912345678"). */
export const normalizeChileanPhone = (raw: string): string => {
  const digits = raw.replace(/\D/g, '');
  if (digits.startsWith('569') && digits.length >= 11) return digits.slice(2, 11);
  if (digits.startsWith('56') && digits.length >= 11) return digits.slice(2, 11);
  if (digits.startsWith('9')) return digits.slice(0, 9);
  return digits.slice(0, 9);
};

/** @param phone - 9-digit Chilean mobile string. @returns true if valid (starts with 9, 9 digits). */
export const isValidChileanPhone = (phone: string): boolean => /^9\d{8}$/.test(phone);

/** @param rutStr - RUT string (e.g. "12.345.678-9"). @returns { rut, dv } or { rut: null, dv: '' } if invalid. */
export const parseRut = (rutStr: string): { rut: number | null; dv: string } => {
  const cleaned = rutStr.replace(/[^0-9kK]/g, '');
  if (cleaned.length < 2) return { rut: null, dv: '' };
  const dv = cleaned.slice(-1).toUpperCase();
  const rutNum = parseInt(cleaned.slice(0, -1), 10);
  if (Number.isNaN(rutNum)) return { rut: null, dv: '' };
  return { rut: rutNum, dv };
};
